/* eslint-disable max-len */
export const ksuHealthText = 'Student Health Services is operated by Wellstar Medical Group. Wellstar Medical Group was'
+ ' founded in 1994 and set out to create a truly integrated health system. Two decades later, Wellstar Medical Group delivers a'
+ ' seamless continuum of healthcare services, including primary, specialty, acute and ambulatory care, and with more than 225 locations'
+ ' and 1,000 providers representing 30 specialties, is one of the largest multi-specialty medical groups in Georgia.';
export default ksuHealthText;
